import React from "react";
import "../PdfViewer.css"; // reuse same CSS for consistency

const SelfAssessmentQuiz = () => {
  const quizzes = [
    {
      id: 1,
      title: "Polynomials",
      desc: "Test your understanding of polynomial concepts with this self-assessment.",
      url: "https://forms.gle/hZhtGwfjGsUJrBT29",
    },
    {
      id: 2,
      title: "Remainder Theorem",
      desc: "Practice applying the remainder theorem to polynomial problems.",
      url: "https://forms.gle/LgQNN6EDAPSEHJKv8",
    },
    {
      id: 3,
      title: "Algebraic Identities",
      desc: "Check your knowledge of algebraic identities through interactive questions.",
      url: "https://forms.gle/JtC9EZ3wGYLTyP2j6",
    },
    {
      id: 4,
      title: "Factorisation",
      desc: "Self-assessment to strengthen your factorisation skills.",
      url: "https://forms.gle/NxPQuc7YCH3JzaPe6",
    },
    {
      id: 5,
      title: "Division of Polynomials",
      desc: "Evaluate your understanding of polynomial division techniques.",
      url: "https://forms.gle/m7Qwgnpx79TCmip3A",
    },
    {
      id: 6,
      title: "GCD",
      desc: "Test your ability to find the Greatest Common Divisor (GCD) in problems.",
      url: "https://forms.gle/HkERQz4DbKzbj7Fn6",
    },
    {
      id: 7,
      title: "Linear Equations in Two Variables",
      desc: "Assess your skills in solving linear equations with two unknowns.",
      url: "https://forms.gle/igXyQDpHGbfEkfQD7",
    },
  ];

  return (
    <section className="pdf-section">
      <h3>Self Assessment Quizzes</h3>
      <div className="pdf-grid">
        {quizzes.map((quiz) => (
          <div key={quiz.id} className="pdf-card">
            <div className="pdf-info">
              <h3>{quiz.title}</h3>
              <p>{quiz.desc}</p>
            </div>
            <div className="pdf-actions">
             
              <a href={quiz.url} target="_blank" rel="noopener noreferrer" className="download-btn">
                Open Quiz
              </a>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default SelfAssessmentQuiz;
